<app-card>
  <app-card-header title="Cohort - Clientes Apostadores">
    <div class="flex flex-1 items-center justify-between flex-wrap gap-4">
      <div class="space-x-4">
        <p-selectbutton
          [options]="[ reportCohortPeriod.DAILY, reportCohortPeriod.MONTHLY ]"
          [(ngModel)]="financialCohortClientsBettorsShow"
          size="small"
        >
          <ng-template let-period #item>
            <div>{{ period | reportCohortPeriod }}</div>
          </ng-template>
        </p-selectbutton>
      </div>
      <form
        [formGroup]="financialCohortClientsBettorsForm"
        class="flex flex-wrap items-center justify-end gap-4"
        (submit)="getFinancialCohortClientsBettors(true)"
      >
        <p-select
          [options]="[reportCohortBasedOn.CREATED, reportCohortBasedOn.EVENT]"
          formControlName="based_by"
          size="small"
        >
          <ng-template let-item #selectedItem>
            <div>{{ item | reportCohortBasedBy }}</div>
          </ng-template>
          <ng-template let-item #item>
            <div>{{ item | reportCohortBasedBy }}</div>
          </ng-template>
        </p-select>
        <p-autocomplete
          id="utm_source_daily"
          formControlName="utm_source"
          [suggestions]="financialCohortClientsBettorsUtmFilter()"
          size="small"
          placeholder="UTM Source"
          (completeMethod)="filterUtmMethodCompleteMethod($event)"
        />
        @if (financialCohortClientsBettorsShow === reportCohortPeriod.DAILY) {
          <p-floatlabel variant="on" class="w-full sm:w-56">
            <p-datepicker
              id="date_range_daily"
              dateFormat="dd/mm/yy"
              formControlName="date_range_daily"
              selectionMode="range"
              [readonlyInput]="true"
              appendTo="body"
              size="small"
              fluid
            />
            <label for="date_range_daily">Período</label>
          </p-floatlabel>
        } @else if (financialCohortClientsBettorsShow === reportCohortPeriod.MONTHLY) {
          <p-floatlabel variant="on" class="w-full sm:w-56">
            <p-datepicker
              id="date_range_daily"
              dateFormat="dd/mm/yy"
              formControlName="date_range_monthly"
              selectionMode="range"
              [readonlyInput]="true"
              appendTo="body"
              size="small"
              fluid
            />
            <label for="date_range_daily">Período</label>
          </p-floatlabel>
        }

        <p-button label="Aplicar" size="small" severity="contrast" variant="outlined" type="submit" />
        @if (
          financialCohortClientsBettorsShow === reportCohortPeriod.DAILY && financialCohortClientsBettorsDailyData() ||
          financialCohortClientsBettorsShow === reportCohortPeriod.MONTHLY && financialCohortClientsBettorsMonthlyData()
        ) {
          <div>
            <p-menu #menu [model]="exportMenuItems" [popup]="true" appendTo="body">
              <ng-template #item let-option>
                <a
                  class="flex items-center px-4 py-2 cursor-pointer group text-zinc-900"
                  (click)="option.action(item, $event); menu.toggle($event); $event.stopPropagation()"
                >
                  <i [class]="option.icon"></i>
                  <span class="ml-2">{{ option.label }}</span>
                </a>
              </ng-template>
            </p-menu>
            <p-button
              size="small"
              variant="text"
              severity="contrast"
              type="button"
              [loading]="exportLoading()"
              (click)="menu.toggle($event)"
              pTooltip="Exportar"
              tooltipPosition="top"
            >
              <i class="fa-solid fa-file-export"></i>
            </p-button>
          </div>
        }
      </form>
    </div>
  </app-card-header>
  @if (financialCohortClientsBettorsShow === reportCohortPeriod.DAILY) {
    @if (financialCohortClientsBettorsDailyLoading()) {
      <div class="w-full h-96 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else {
      @if (financialCohortClientsBettorsDailyFirstRequest()) {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-4">
          <i class="fa-solid fa-chart-gantt text-4xl text-zinc-500"></i>
          <span class="text-zinc-500 text-sm">Selecione um período e aplique para ver os dados</span>
        </div>
      } @else if (!financialCohortClientsBettorsDailyData()?.cohorts?.length) {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-4">
          <app-empty-chart />
        </div>
      } @else {
        <p-table id="financialCohortClientsBettorsDailyTable" [value]="financialCohortClientsBettorsDailyData()?.cohorts">
          <ng-template #header>
            <tr>
              <th class="text-xs py-1.5 px-1">Data</th>
              <th class="text-xs py-1.5 px-1">Total</th>
              @for (item of financialCohortClientsBettorsDailyData()?.cohorts[0].periods; track $index) {
                <th class="text-xs text-center py-1.5 px-1">{{ item.title }}</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-item>
            <tr>
              <td class="text-xs font-semibold py-1.5 px-1">{{ item.dia_coorte | date: 'dd/MM' }}</td>
              <td class="text-xs font-semibold py-1.5 px-1">{{ item.jogadores_no_coorte }}</td>
              @for (period of item.periods; track $index) {
                <td
                  class="text-xs text-center text-white font-semibold py-1.5 px-1"
                  [ngStyle]="{ 'background-color': color(+period.label) }">
                    {{ +period.label > 0 ? period.label + '%' : '' }}<br>
                    {{ +period.tooltip > 0 ? period.tooltip : '' }}
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    }
  } @else if (financialCohortClientsBettorsShow === reportCohortPeriod.MONTHLY) {
    @if (financialCohortClientsBettorsMonthlyLoading()) {
      <div class="w-full h-96 flex items-center justify-center">
        <p-progress-spinner strokeWidth="4" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px' }" />
      </div>
    } @else {
      @if (financialCohortClientsBettorsMonthlyFirstRequest()) {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-4">
          <i class="fa-solid fa-chart-gantt text-4xl text-zinc-500"></i>
          <span class="text-zinc-500 text-sm">Selecione um período e aplique para ver os dados</span>
        </div>
      } @else if (!financialCohortClientsBettorsMonthlyData()?.cohorts?.length) {
        <div class="w-full h-96 flex flex-col items-center justify-center gap-4">
          <app-empty-chart />
        </div>
      } @else {
        <p-table id="financialCohortClientsBettorsMonthlyTable" [value]="financialCohortClientsBettorsMonthlyData()?.cohorts">
          <ng-template #header>
            <tr>
              <th class="text-xs py-1.5 px-1">Data</th>
              <th class="text-xs py-1.5 px-1">Total</th>
              @for (item of financialCohortClientsBettorsMonthlyData()?.cohorts[0].periods; track $index) {
                <th class="text-xs text-center py-1.5 px-1">{{ item.title }}</th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-item>
            <tr>
              <td class="text-xs font-semibold py-1.5 px-1">{{ item.mes_coorte | date: 'MM/y' }}</td>
              <td class="text-xs font-semibold py-1.5 px-1">{{ item.jogadores_no_coorte }}</td>
              @for (period of item.periods; track $index) {
                <td
                  class="text-xs text-center text-white font-semibold py-1.5 px-1"
                  [ngStyle]="{ 'background-color': color(+period.label) }">
                  {{ +period.label > 0 ? period.label + '%' : '' }}<br>
                  {{ +period.tooltip > 0 ? period.tooltip : '' }}
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    }
  }
</app-card>
